import React, { useState } from 'react';
import { TextField } from '@mui/material';

import { Control, Controller } from 'react-hook-form';
import { validations } from '@shared/infrastructure/ui/validations';
import { Content } from '@shared/domain/content/content.aggregate';

export const ContentInfo = ({
  control
}: {
  control: Control<Content, any>;
}) => {
  return (
    <>
      <Controller
        name='name'
        control={control}
        rules={validations.notWhiteSpace()}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            sx={{ my: '0.3rem' }}
            label='Identifier'
            placeholder='example-url'
          />
        )}
      />
      <Controller
        name='nameLanguage'
        control={control}
        rules={validations.notWhiteSpace()}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            sx={{ my: '0.3rem' }}
            label='Displayname'
          />
        )}
      />
      <Controller
        name='thumbnailUrl'
        control={control}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            sx={{ my: '0.3rem' }}
            label='Thumbnail URL (optional)'
          />
        )}
      />
    </>
  );
};
